import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import centresApi from 'api/masterCentresApi';
import { logout } from '../auth/index';
import { SELECTED_CENTRES } from 'helpers/storage';
import { handleToastError } from 'helpers';
import { deleteCookie, setCookie } from 'cookies-next';

let vl = typeof window !== 'undefined' ? SELECTED_CENTRES.get() : null;
const value =
  typeof vl !== 'undefined' && vl !== null && vl !== ''
    ? JSON.parse(vl)
    : undefined;

const initialState = {
  centresList: [],
  selectedCentre: value,
};

export const masterSlice = createSlice({
  name: 'master',
  initialState,
  reducers: {
    setCentresList: (state, action) => {
      state.centresList = action.payload;
    },
    setSelectedCentre: (state, action) => {
      if (action.payload) {
        setCookie('selectedCentre', action.payload?._id);
      } else {
        deleteCookie('selectedCentre');
      }
      state.selectedCentre = action.payload;
    },
  },
  extraReducers: {
    [logout]: (state) => initialState,
  },
});

export const { setCentresList, setSelectedCentre } = masterSlice.actions;

/**
 * @return {CourseCentre[] | undefined}
 */
export const getCentresList = (state) => state.master.centresList;

/**
 * @return {CourseCentre | undefined}
 */
export const getSelectedCentre = (state) => state.master.selectedCentre;

export const getAllCentresAsync = (val) => async (dispatch) => {
  try {
    const response = await centresApi.get(val);
    return dispatch(setCentresList(response?.data));
  } catch (e) {
    handleToastError(e);
  }
};

export default masterSlice.reducer;
